/**
 * Local-dev mock used by LoginPage when the real backend isn't reachable.
 * Pretends to be /auth/login → returns a fake user with permissions.
 *
 * Toggle via VITE_USE_MOCK_AUTH=true in .env.
 *
 * SECURITY: This file MUST NEVER run in production. The guard below throws
 * at import time if both flags are set, so a misconfigured prod build refuses
 * to start instead of silently signing users in as super_admin.
 */
import { ROLES } from '@/auth/roles'
import type { User, LoginDto } from '@/types/user'
import { mockPermissionsForRole } from './permissions.mock'

export const USE_MOCK_AUTH =
  String(import.meta.env.VITE_USE_MOCK_AUTH ?? '').toLowerCase() === 'true'

if (import.meta.env.PROD && USE_MOCK_AUTH) {
  console.error(
    '[ShopsZe Admin] FATAL: VITE_USE_MOCK_AUTH=true in a production build. Refusing to start.',
  )
  throw new Error('VITE_USE_MOCK_AUTH must be false in production builds')
}

export function mockLogin(payload: LoginDto): User {
  const role = ROLES.SUPER_ADMIN
  return {
    id: 'mock-user-1',
    name: 'مدير التطوير',
    email: payload.email ?? 'admin@shopsze.local',
    phone: payload.phone,
    role,
    permissions: mockPermissionsForRole(role),
    status: 'active',
    createdAt: new Date().toISOString(),
  }
}
